import { makeAutoObservable } from 'mobx';
import { UserDetailsLecturerRes } from '../api/types/lecturers/user-details-lecturer';
import { UserDetailsStudent } from '../api/types/students/user-details-student';
import { UserDetailsAdministrationResponse } from '../api/types/administration/user-details-administration';

class GlobalUserPage {
  loading = false;

  lecturerDetails: UserDetailsLecturerRes | null = null;
  studentDetails: UserDetailsStudent | null = null;
  administrationDetails: UserDetailsAdministrationResponse | null = null;
  constructor() {
    makeAutoObservable(this, {}, { deep: true }); // Just add deep: true
  }
}
const globalUserPage = new GlobalUserPage();
export default globalUserPage;
